import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import GraficoPadrao from './graficoPadrao';

export default class GraficoLinha extends GraficoPadrao {

    constructor(props) {
        super(props);

        this.CustomTooltip = this.CustomTooltip.bind(this);
    }

    CustomTooltip({ active, payload, label }) {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <div style={{ backgroundColor: '#DBF1E9' }}>
                        <p className="label">{this.props.label}</p>
                        <p className="intro" style={{ fontWeight: "bold" }}>{this.props.intro}</p>
                        <p className="desc">{`${label} -> ${payload[0].value}`}</p>
                    </div>
                </div>
            );
        }

        return null;
    };

    render() {
        return (
            <ResponsiveContainer width={this.props.width} height={this.props.height} debounce={1}>
                <LineChart
                    data={this.props.data}>
                    <CartesianGrid strokeDasharray="3 3" stroke={this.props.gridColor} />
                    <XAxis dataKey={this.props.dataKeyXAxis} />
                    <YAxis />
                    <Tooltip content={this.CustomTooltip} />
                    <Line
                        type="monotone"
                        dataKey={this.props.dataKeyLine}
                        stroke={this.props.lineColor}
                        strokeWidth={5}
                        dot={{ r: 5 }}
                        activeDot={{ r: 10 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        );
    }
}